import { StringUtils } from '@/common/utils/stringUtils';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { decorateReward, useStarterPackReward } from '@/modules/starter/pack/reward/model/mixins';
import { StarterPackRewardDetail } from '@/modules/starter/pack/reward/types';
import { starterPackService } from '@/services/starter';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

export function useStarterPackRewardList() {
    const route = useRoute();
    const { executeAction, confirmAndRemove } = useCrudActions();

    const starterPackId = StringUtils.toNumber(route.params.starterPackId);
    const canUpdateReward = ref(false);

    const { fetchLinkableRewards, linkableRewards } = useStarterPackReward();
    const loadAndSetDataStarterPackItem = executeAction({
        canExecute: () => starterPackId != null,
        request: () => starterPackService.get(starterPackId),
        onSuccess: ({ data }) => void (canUpdateReward.value = data.canEnable)
    });

    onMounted(async () => await Promise.all([fetchLinkableRewards(), loadAndSetDataStarterPackItem()]));

    const { list, total, fetchList } = useBaseListView({
        request: starterPackService.reward.list,
        paramsBuilder: () => ({ starterPackId }),
        hooks: {
            transformResponse: (items: StarterPackRewardDetail[]) =>
                items.map(item => decorateReward(item, linkableRewards.value))
        }
    });

    const actions = {
        remove: confirmAndRemove({
            request: (type, data) => starterPackService.reward.remove(starterPackId, type, data),
            onSuccess: () => fetchList()
        })
    };

    return { list, total, fetchList, starterPackId, actions, canUpdateReward };
}
